import { useState } from 'react';
import axios from 'axios';
import './Login.css';

const Register = () => {
  const [form, setForm] = useState({
    name: '',
    company: '',
    username: '',
    password: '',
    confirmPassword: ''
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    const name = form.name.trim();
    const company = form.company.trim();
    const username = form.username.trim().toLowerCase();
    const password = form.password;
    const confirmPassword = form.confirmPassword;

    if (!name || !username || !password) {
      alert('Nombre, usuario y contraseña son obligatorios.');
      return;
    }

    if (username.length < 4) {
      alert('El usuario debe tener al menos 4 caracteres.');
      return;
    }

    if (password.length < 6) {
      alert('La contraseña debe tener al menos 6 caracteres.');
      return;
    }

    if (password !== confirmPassword) {
      alert('Las contraseñas no coinciden.');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        '/api/auth/register',
        {
          name,
          company: company || name,
          username,
          password
        },
        { headers: { 'Content-Type': 'application/json' } }
      );

      alert(response.data.message || 'Cuenta creada correctamente. Ya puedes iniciar sesión.');
      window.location.href = '/';
    } catch (error) {
      if (error.response) {
        alert(error.response.data.message || error.response.data.error || 'Error al crear la cuenta.');
      } else if (error.request) {
        alert('No se recibió respuesta del servidor.');
      } else {
        alert(`Error: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg-shape login-bg-shape-1"></div>
      <div className="login-bg-shape login-bg-shape-2"></div>

      <div className="register-card">
        <div className="register-header">
          <div className="register-logo-box">
            <img src="/elicrom-logo.png" alt="ELICROM" className="register-logo" />
          </div>

          <h1>Crear cuenta</h1>
          <p>
            Registra una cuenta gratuita para monitoreo de sensores.
          </p>
        </div>

        <form className="login-form" onSubmit={handleRegister}>
          <div className="login-input-group">
            <label className="login-label">Nombre completo</label>
            <div className="login-input-box">
              <span className="login-input-icon">👤</span>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Ejemplo: Juan Pérez"
                className="login-input"
                autoComplete="name"
                required
              />
            </div>
          </div>

          <div className="login-input-group">
            <label className="login-label">Empresa o cuenta</label>
            <div className="login-input-box">
              <span className="login-input-icon">🏢</span>
              <input
                type="text"
                name="company"
                value={form.company}
                onChange={handleChange}
                placeholder="Ejemplo: Laboratorio ABC"
                className="login-input"
                autoComplete="organization"
              />
            </div>
          </div>

          <div className="login-input-group">
            <label className="login-label">Usuario</label>
            <div className="login-input-box">
              <span className="login-input-icon">🏷️</span>
              <input
                type="text"
                name="username"
                value={form.username}
                onChange={handleChange}
                placeholder="Ejemplo: laboratorioabc"
                className="login-input"
                autoComplete="username"
                required
              />
            </div>
          </div>

          <div className="login-input-group">
            <label className="login-label">Contraseña</label>
            <div className="login-input-box">
              <span className="login-input-icon">🔒</span>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Mínimo 6 caracteres"
                className="login-input"
                autoComplete="new-password"
                required
              />
            </div>
          </div>

          <div className="login-input-group">
            <label className="login-label">Confirmar contraseña</label>
            <div className="login-input-box">
              <span className="login-input-icon">🔐</span>
              <input
                type="password"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                placeholder="Repite tu contraseña"
                className="login-input"
                autoComplete="new-password"
                required
              />
            </div>
          </div>

          <div className="register-plan-box">
            <strong>Cuenta gratuita incluida</strong>
            <span>
              Hasta 3 dispositivos, reportes de máximo 30 días y acceso básico a datos.
            </span>
          </div>

          <button
            type="submit"
            className={`login-button ${loading ? 'is-loading' : ''}`}
            disabled={loading}
            aria-busy={loading}
          >
            {loading ? 'CREANDO CUENTA...' : 'CREAR CUENTA'}
          </button>

          <button
            type="button"
            className="login-create-button"
            onClick={() => window.location.href = '/'}
          >
            Volver al inicio de sesión
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;
